import {RiskModel} from "@/services/ModelRisk/RiskModel";

export class VersionService {
    async findByRiskModelId(riskModelId) {
        return await axios.get(`${RiskModel.endpoint}/version?risk_model_id=${riskModelId}`)
    }
    async update(id, version) {
        return await axios.post(`${RiskModel.endpoint}/version/${id}`, version)
    }
}
